import { useEffect, useState } from "react";

import { CitySearchResDTO, InputValuesResDTO } from "../models";

type SelectOptions = { value: string; label: string }[];
type ReturnType = Record<keyof InputValuesResDTO["forms"], SelectOptions>;

export const useConvertToSelectOptionsSet = (
  data?: InputValuesResDTO,
): ReturnType | null => {
  const [optionsArray, setOptionsArray] = useState<ReturnType | null>(null);

  useEffect(updateOptionsArray, [data]);

  function updateOptionsArray() {
    if (!data) return;
    const forms = data.forms;

    setOptionsArray(
      (obj) =>
        ({
          ...(obj ? { ...obj } : {}),
          country: forms.country.map((item) => {
            return { label: item.country, value: String(item.uid) };
          }),
        } as ReturnType),
    );

    setOptionsArray(
      (obj) =>
        ({
          ...obj,
          zodiac: forms.zodiac.map((item) => {
            return { label: item.name, value: String(item.uid) };
          }),
        } as ReturnType),
    );

    const dataKeys = Object.keys(data.forms) as (keyof typeof data.forms)[];

    dataKeys.forEach((key) => {
      if (key === "country" || key === "zodiac") return;
      type OmitedForm = Omit<InputValuesResDTO["forms"], "country" | "zodiac">;
      const excludedForms = forms as OmitedForm;

      setOptionsArray(
        (obj) =>
          ({
            ...obj,
            [key]: excludedForms[key].map((item) => {
              return { label: item.name, value: String(item.uid) };
            }),
          } as ReturnType),
      );
    });
    return;
  }

  if (!data) return null;
  return optionsArray;
};

export const useConvertCityOptions = (
  cities?: CitySearchResDTO,
): SelectOptions => {
  return !!cities?.forms
    ? cities.forms.map((city) => {
        return { label: city.name, value: String(city.uid) };
      })
    : [];
};
